/** Removes editor-only comment annotations while preserving the prose. */
export function sanitizeAssembledProse(html: string): string {
  if (!html) return '';
  const withoutMarkedSpans = html.replace(/<span[^>]*data-comment-id[^>]*>([\s\S]*?)<\/span>/gi, (_all, inner: string) => inner);
  const withoutIds = withoutMarkedSpans.replace(/\sdata-comment-id="[^"]*"/gi, '').replace(/\sdata-comment-id='[^']*'/gi, '');
  return withoutIds.replace(/\sclass="commented-paragraph"/gi, '').replace(/\sclass='commented-paragraph'/gi, '');
}
